import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import myFooter from "@/components/common/my-footer.vue";
import myHeader from "@/components/common/my-header.vue";
import navigationMenu from "@/components/common/navigation-menu.vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    var isShowMenu = ref(false);
    function clickShowMenu() {
      isShowMenu.value = !isShowMenu.value;
    }
    function hideMenu(scrollToTop) {
      isShowMenu.value = false;
      if (scrollToTop) {
        scrollTo({
          top: 0,
          behavior: "instant"
        });
      }
    }
    function redirectToIndex() {
      scrollTo({
        top: 0,
        behavior: "instant"
      });
    }
    return (_ctx, _cache) => {
      const _component_metainfo = _resolveComponent("metainfo");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_metainfo, null, {
        title: _withCtx(({
          content
        }) => [_createTextVNode(_toDisplayString(content ? `${content}` : `SITE_NAME`), 1)]),
        _: 1
      }), _createVNode(myHeader, {
        class: "root-navigation",
        "is-show-menu": _unref(isShowMenu),
        onClickShowMenu: clickShowMenu,
        onRedirectToIndex: redirectToIndex
      }, null, 8, ["is-show-menu"]), _createVNode(_component_router_view, {
        class: "root-content pc-root-content"
      }), _createVNode(myFooter), _withDirectives(_createVNode(navigationMenu, {
        class: "root-navigation-menu pc-root-navigation-menu",
        onHideMenu: hideMenu
      }, null, 512), [[_vShow, _unref(isShowMenu)]])]);
    };
  }
});